export default __webpack_public_path__ + "static/media/0712d2929f9806ceb61a4d239ab134f2.svg";